const PROMISE_REJECTED = 'rejected'

export const getInitialProps = async ({routeInfo, context: {domain, i18n, pde}}) => {
  const {
    location: {pathname: path}
  } = routeInfo

  const {culture} = i18n
  const config = domain.get('config')
  const {MAKES_SIZES_DISTRIBUTOR_PAGE_NAME} = config.get('page')
  const serverErrors = []

  const {pageName} = (await domain.get('get_page_name_page_use_case').execute({path})) || {}

  const isMakesSizesPage = pageName === MAKES_SIZES_DISTRIBUTOR_PAGE_NAME
  const getCarouselsUseCase = isMakesSizesPage
    ? 'get_carousels_sizes_info_vehicles_use_case'
    : 'get_carousels_info_vehicles_use_case'

  const [
    {
      status: getCarouselsInfoStatus,
      value: [carouselsInfoError, carouselsInfoResponse]
    },
    {
      status: getSeoDataStatus,
      value: [seoDataError, seoDataResponse]
    }
  ] = await Promise.allSettled([
    domain.get(getCarouselsUseCase).execute({pageName}),
    domain.get('get_seo_data_use_case').execute({
      culture,
      pageName
    })
  ])

  if (getCarouselsInfoStatus === PROMISE_REJECTED) {
    serverErrors.push(carouselsInfoError)
    return {}
  }
  const {carousels} = carouselsInfoResponse

  if (getSeoDataStatus === PROMISE_REJECTED) {
    serverErrors.push(seoDataError)
  }
  const {head: helmet = {}, h1} = seoDataResponse || {}

  return {
    carousels,
    h1,
    helmet,
    pageName
  }
}
